import { firebaseAnalytic } from './firebase'

export default function trackGa(category, name, params, user) {
  const account = user && user.account
  const telco = user && user.telco

  if (params) {
    if (account) {
      params.userId = account.userId
    }
    if (telco) {
      params.telco = telco.operator
      firebaseAnalytic.setUserProperties({ telco: telco.operator })
    }
    firebaseAnalytic.logEvent(`${category}_${name}`, params);
    window.gtag('event', `${category}_${name}`, params)
  } else {
    firebaseAnalytic.logEvent(`${category}_${name}`);
    window.gtag('event', `${category}_${name}`)
  }
}

export function trackPage(pageName) {
  const param = {
    screen_name: pageName
  }
  firebaseAnalytic.logEvent(`screen_view`, param);
  window.gtag('event', 'screen_view', param)
}
